var _circle, _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#BD9F00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0002 64.8012C20.0882 64.8012 7.2002 51.9132 7.2002 36.0012C7.2002 20.0892 20.0882 7.20117 36.0002 7.20117C51.9122 7.20117 64.8002 20.0892 64.8002 36.0012C64.8002 51.9132 51.9122 64.8012 36.0002 64.8012Z",
    fill: "#F0B23B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33.5,
    y: 19,
    width: 5,
    height: 25,
    rx: 2.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33.5,
    y: 49,
    width: 5,
    height: 5,
    rx: 2.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning_icon.cd3a82f5685572a1a3da30001389a937.svg";
export { ForwardRef as ReactComponent };